import {
  complexHistoryOperationsFilter,
  complexHistoryOperationsFilterSelection,
  defaultComplexHistoryOperationsData,
  defaultComplexHistoryOperationsSelection,
  defaultPeriod,
  periodFilter,
} from 'app/dataProviders/filter-items'

type DefaultValues = {
  operation: Array<string>
  period: Array<string>
}

export const filterInit = ({ operation, period }: DefaultValues) => {
  complexHistoryOperationsFilter.updateData(defaultComplexHistoryOperationsData)
  complexHistoryOperationsFilter.setStatusReady()

  complexHistoryOperationsFilterSelection.setDefault(
    defaultComplexHistoryOperationsSelection,
  )
  complexHistoryOperationsFilterSelection.updateData(() => operation)
  periodFilter.setDefault(defaultPeriod)
  periodFilter.updateData(() => period)

  return () => {
    complexHistoryOperationsFilterSelection.reset()
    complexHistoryOperationsFilter.reset()
    periodFilter.reset()
  }
}

export const resetToDefaultAll = () => {
  complexHistoryOperationsFilterSelection.resetToDefault()
  periodFilter.resetToDefault()
}
